import React from 'react';

import { useIntl } from 'react-intl';

import { ILinkWidgetFragment, IVerticalLinkListWidgetFragment } from 'generated/sanity-graphql';
import { useLocale } from 'state/intl';

import { Links } from './links';
import { PaddedExternalLink, PaddedInternalLink, VerticalLinksContainer } from './styled';

// Sanity column `_key` that should render the OneTrust cookie-preferences link.
const COOKIE_PREFERENCES_COLUMN_KEY: Record<string, string> = {
  ca: 'e0be420fddbc',
  us: '9139100a928b',
};

type IVerticalLinkListProps = IVerticalLinkListWidgetFragment & {
  columnKey?: string | null;
};

export const VerticalLinkList: React.FC<IVerticalLinkListProps> = ({ columnKey, ...props }) => {
  const { formatMessage } = useIntl();
  const { region } = useLocale();

  const showCookiePreferences =
    !!columnKey && columnKey === COOKIE_PREFERENCES_COLUMN_KEY[region.toLowerCase()];

  return (
    <VerticalLinksContainer>
      <Links
        links={props.linkWidgets as ILinkWidgetFragment[]}
        InternalLink={PaddedInternalLink}
        ExternalLink={PaddedExternalLink}
      />
      {showCookiePreferences && (
        <PaddedExternalLink onClick={() => window?.OneTrust?.ToggleInfoDisplay?.()}>
          {formatMessage({ id: 'cookiePreferences' })}
        </PaddedExternalLink>
      )}
    </VerticalLinksContainer>
  );
};
